import type { RequestConfig } from "@app/config/axios/http";
import { lotsApi } from "./api.core";
import type { StockAvailableLot, StockAvailableLotFilter, StockLot, StockLotFilter } from "./types";

/** Сервисный слой — партии СУ/УП. */
export const lotsServices = {
    ...lotsApi,

    /**
     * Загружает партии по фильтру.
     * @param params фильтр партий
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockLotFilter;
        },
        config?: RequestConfig,
    ): Promise<StockLot[]> => {
        return lotsApi.load(params, config);
    },

    /**
     * Загружает доступные партии СУ/УП по фильтру.
     * @param params фильтр доступных партий
     * @param config опции HTTP-запроса
     */
    getAvailableLots: async (
        params: {
            flt?: StockAvailableLotFilter;
        },
        config?: RequestConfig,
    ): Promise<StockAvailableLot[]> => {
        return lotsApi.getAvailableLots(params, config);
    },
} as const;
